<app-button [disabled]="searching" [small]="true" buttonType="outline-secondary" (onClick)="clickEvent()">Clear</app-button>